import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Lottie from "lottie-react";
import { useApp } from "../../services/app-context";
import { Button } from "../../components/Button";
import * as dotsAnimation from "../../assets/loading-dots.json";
export function SignOut() {
  const { logout } = useApp();
  const navigate = useNavigate();
  // logout() rejects when the backend revoke fails — the session is still
  // valid at that point, so offer a way back instead of stranding the user on
  // this sidebar-less route.
  // loggedOut starts false so the first paint is the loading state, never the
  // success state — the effect below hasn't called logout() yet at that point.
  const [loggedOut, setLoggedOut] = useState(false);
  const [logoutFailed, setLogoutFailed] = useState(false);

  const runLogout = useCallback(async () => {
    setLogoutFailed(false);
    try {
      await logout();
      setLoggedOut(true);
    } catch {
      setLogoutFailed(true);
    }
  }, [logout]);

  useEffect(() => {
    void runLogout();
  }, []);

  const handleLogin = () => {
    window.location.href = "/login";
  };

  const handleBackToApp = () => {
    // Back to wherever they signed out from; a direct landing on /signout has
    // no history to go back to, so fall through to the dashboard.
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/dashboard");
    }
  };

  return (
    <div className="h-screen">
      <div className="flex items-center p-3.5 h-[100vh]">
        <div className="flex-1 h-[100vh] lg:h-auto flex flex-col items-center justify-center overflow-auto px-4 md:px-0">
            {logoutFailed ? (
              <>
                <h1 className="text-3xl font-bold">We couldn&apos;t log you out</h1>
                <p className="text-center text-text-secondary max-w-md">
                  You&apos;re still signed in. Check your connection and try again, or go back to the app.
                </p>
                <div className="flex gap-3">
                  <Button variant="primary" className="!py-4 !rounded-full" onClick={() => void runLogout()}>Try again</Button>
                  <Button variant="outline" className="!py-4 !rounded-full" onClick={handleBackToApp}>Back to the app</Button>
                </div>
              </>
            ) : loggedOut ? (
              <>
                <h1 className="text-3xl font-bold">You have been logged out</h1>
                {/** login again */}
                <Button variant="primary" className="!py-4 !rounded-full" onClick={handleLogin}>Login again</Button>
              </>
            ) : (
              <>
                <h1 className="text-3xl font-bold">Logging out...</h1>
                <Lottie animationData={dotsAnimation} loop={true} className="w-[120px] h-[64px]" />
              </>
            )}
        </div>
      </div>
    </div>
  )
}
